import React from "react";
import {CarbideFrontendAPI} from "./CarbideFrontendAPI";

export const CarbideFrontendAPIContext = React.createContext<CarbideFrontendAPI>(
    new CarbideFrontendAPI()
);
